import { Menu } from '@/components/organisms/Menu/Menu'
import React from 'react'
import benef from '@/styles/benefits/index.module.scss'
import { Footer } from '@/components/organisms/Footer/Footer'
import Image from 'next/image'
import { BenefitCard } from '@/components/organisms/BenefitCard/BenefitCard'
import { benefits } from '@/data/dummy/benefits'

export default function index () {
  function chunk (arr, size) {
    return arr.reduce((result, item, index) => {
      const chunkIndex = Math.floor(index / size)
      if (!result[chunkIndex]) {
        result[chunkIndex] = []
      }
      result[chunkIndex].push(item)
      return result
    }, [])
  };
  const benefitslGrups = chunk(benefits, 3)
  return (
    <>

      <Menu />
      <div className={benef.containes}>
        <div className={benef.body_section}>
          <div className={benef.image_container}>
            <Image
              src='/img/benefits/beneficios.png'
              className={benef.logo1}
              alt='Picture of the author '
              width={690}
              height={519}
            />
          </div>
          <div className={benef.title_container}>
            <h2 className={benef.title1}>Módulos y<br className={benef.break} /> <br className={benef.break} /> características</h2>
            <p className={benef.text}>Sabemos exactamente lo que necesitas para tener todo bajo control en tu recicladora, por eso integramos:</p>
          </div>
        </div>
        {
            benefitslGrups.map((group, index) => (
              <div key={index} className={benef.body_section}>
                {
                   group.map((benefits, index) => (
                     <BenefitCard key={index} {...benefits} />
                   ))
                }
              </div>

            ))
          }

      </div>
      <Footer />
    </>
  )
}
